import React, {Component, useState} from 'react';
import axios from "axios";
import config from 'react-global-configuration';
import $ from 'jquery';
import {Button, Collapse, Input, Label, Modal, ModalBody, ModalFooter, Card, CardBody, CardText} from 'reactstrap';
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Select from 'react-select';
import Switch from 'react-switch';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
//import {confirmAlert} from 'react-confirm-alert';
import ReactTooltip from 'react-tooltip';
import jwt_decode from "jwt-decode";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SimpleReactValidator from 'simple-react-validator';
import {Link} from 'react-router-dom';
import AsyncPaginate, {reduceGroupedOptions} from 'react-select-async-paginate';
import moment from 'moment';
import loadOptions from './loadOptions';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class MerchantUpload extends Component{
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            brand_file_uploaded: [],
            mvalue: { year: new Date().getFullYear(), month: 11 },
            fileType: 'Base and EMI',
            _notificationSystem: null,
            timer: null,
            loading: false,
            isSubmit: false,
            mapField: false,
            file_name: "",
            notify: null,
            activer:[],
            is_download: false,
            uploadDropdown: false,
            merchant2_display_data: [],
            user_id: null,
            merchant_file_name: null,
            merchant3_data: []
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount(){
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        //var _notificationSystem = this.refs.notificationSystem;
        this.getMerchantMappingData();
    }

    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    handleChange(checked) {
        //console.log(e.target.value);
        this.setState({
            checked
        });
    }


    fileUploadHandler = () => {
        const timer1 = (Date.now()).toString();
        //console.log(timer1);
        this.setState({
            timer: timer1,
            isSubmit: true,
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        let random_string = timer1 + '_' + decoded._id + '_';
        data.append('file', this.state.selectedFile);
        data.append('fileType', this.state.fileType);
        data.append('userID', decoded._id);
        data.append('timer', this.state.timer);
        data.append('timer1', timer1);
        data.append('random_string', random_string);
        // let random_string = Date.now()+'_'+req.body.userID+'_';
        data.append('userGroup', decoded.userGroup);
        if(this.state.selectedFile == null){
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                isSubmit: false,
                loading: false
            });
        }
        else{
            var file = this.state.selectedFile;
            var ext = this.getFileExtension(file.name);
            console.log(file.name);
            console.log(ext);
            if (ext === 'csv') {
                axios.post(config.get('API_URL') + "/brandemi/upload_merchant_master/", data, {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                .then(res => {
                    console.log(res);
                    this.setState({
                        isSubmit: false,
                        loading: false,
                        notify: res.data.notify,
                        merchant_file_name: random_string + file.name,
                        merchant3_data: res.data
                    });
                    //console.log(res.data.notify);
                    //console.log(res.data.inconsistent);
                    if (res.data.success !== undefined && res.data.notify !== undefined && res.data.inconsistent === 0) {
                        
                        if (res.data.notify === 1){
                            this.handleNotificationClick("tr", 2, "File with same name uploaded. If you continue, old file will be overwritten.");
                        }

                        else{
                            this.handleNotificationClick("tr", 1, res.data.success);
                        }
                        
                        // this.setState({
                        //     isSubmit: false,
                        //     loading: false,
                        //     notify: res.data.notify,
                        //     merchant_file_name: random_string + file.name,
                        //     merchant3_data: res.data
                        // });
                        console.log(res.data);
                        this.openSectionToMap(true);
                    } 
                    
                    else {
                        if (res.data.inconsistent === 1){
                            this.handleNotificationClick("tr", 3, "There are inconsistencies");
                        }
                        else{
                            this.handleNotificationClick("tr", 3, res.data.error);
                        }
                        this.setState({
                            isSubmit: false,
                            loading: false
                        });
                    }
                })
                .catch(err => { // then print response status
                    this.handleNotificationClick("tr", 3, "Something Wrong!");
                    this.setState({
                        isSubmit: false,
                        loading: false
                    });
                    // this.openSectionToMap(true); // remove and place in success block
                })
            }
            else {
                this.handleNotificationClick("tr", 3, "Please upload valid file");
                this.setState({
                    isSubmit: false,
                    loading: false
                });
            }
        }
    };




    downloadCSV = (file_id) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: "/brandemi/download_csv_brand?file_id=" + file_id,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName = xhr.getResponseHeader('Content-Disposition').split("=")[1];
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    onChangeHandler = event => {
        var file = event.target.files[0];
        var ext = this.getFileExtension(file.name);
        if (ext === 'csv') {
            this.setState({
                selectedFile: file,
                file_name: file.name
            });
        } else {
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                selectedFile: file
            });
        }
    };

    getMerchantMappingData(){
        if ($.fn.DataTable.isDataTable('#merchant_showTable')) {
            $('#merchant_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/view_merchant_maintainer',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            //console.log(response.data);
            this.setState({
                merchant2_display_data: response.data
            });
            $('#merchant_showTable').DataTable();
            this.setState({
                loading: false,
                user_id: decoded._id
            });
        });
    }

    render(){
        console.log(this.state.merchant_file_name);
        console.log(this.state.merchant3_data);
        let merchant_maintainer_data = this.state.merchant2_display_data.map((value, index) =>{
            return (
                <tr key={index + 1}>
                <td>{index+1}</td>
                <td>{value.merchant_id}</td>
                <td>{value.merchant_name}</td>
                <td>{value.merchant_code}</td>
                <td>{value.chain_id}</td>
                <td>{value.chain_name}</td>
                <td>{value.chain_code}</td>
                <td>{value.store_id}</td>
                <td>{value.store_name}</td>
                <td>{value.store_code}</td>
                <td>{value.store_address}</td>
            </tr>
            )
        });

        return(<div>
            <div className="col-md-12">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className='sweet-loading'>
                    <BeatLoader
                        css={override}
                        sizeUnit={"px"}
                        size={20}
                        color={'#123abc'}
                        loading={this.state.loading}
                    />
                </div>
                <Button color="primary" className="pull-right" name="download" onClick={this.downloadCSV.bind(this, this.state.user_id)}>Download Sample File</Button>
                <div className="card">
                    <div className="header">
                        Applicable Merchants
                    </div>
                
                <hr/>
                    <div className="content">
                        <div className="row">
                            <div className="container-fluid">
                                <div className="content table-full-width table-responsive">    
                                    <table className="table table-striped table-hover" id="merchant_showTable">
                                        <thead>
                                            <tr>
                                                <th>Sr No.</th>
                                                <th>Merchant ID</th>
                                                <th>Merchant Name</th>
                                                <th>Merchant Code</th>
                                                <th>Chain ID</th>
                                                <th>Chain Name</th>
                                                <th>Chain Code</th>
                                                <th>Store ID</th>
                                                <th>Store Name</th>
                                                <th>Store Code</th>
                                                <th>Store Address</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {merchant_maintainer_data}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                <div className="card">
                    <div className="header">
                        <h4 className="title">Upload Merchant Mapping</h4>
                    </div>
                    <hr/>
                    <div className="content">
                        <form method="post" action="#" id="#">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="queryName" className="">Upload Your CSV File</label>
                                        <input type="file" name="file" className="form-control" onChange={this.onChangeHandler} />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                        <div className="row">
                                        <label htmlFor="sampleName">Sample File</label>
                                        </div>
                                        <div className="row">
                                            <Button color="primary" name="download" onClick={this.downloadCSV.bind(this, 'the_sample_template.csv')}>Download Sample File</Button>
                                        </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="row">
                                        <label htmlFor="sampleName">CSV Rules</label>
                                    </div>
                                    <div className="row">
                                    <Card>
                                        <CardBody>
                                        <CardText>
                                            Lorem Ipsum
                                        </CardText>
                                        </CardBody>
                                    </Card>  
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <button type="button" className="btn btn-primary" onClick={this.fileUploadHandler.bind(this)} disabled={this.state.isSubmit}>Upload File</button>
                                </div>
                                <div className='sweet-loading'>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />
                                </div>
                            </div>
                            <div className="clearfix"></div>
                        </form>
                        <div className="footer">
                            <div className="stats"><i></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}
export default MerchantUpload;